import { Icon } from '@chakra-ui/react';

export const NetchexEngagement = (props) => (
  <Icon viewBox="0 0 20 20" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M5.92769 6H12.5943M5.92769 10H9.73719M9.48876 13.8261L5.51361 18V13.8261H4.02293C2.97095 13.8261 2.11816 12.9307 2.11816 11.8261V4C2.11816 2.89543 2.97095 2 4.02293 2H15.4515C16.5035 2 17.3562 2.89543 17.3562 4V11.8261C17.3562 12.9307 16.5035 13.8261 15.4515 13.8261H9.48876Z"
      stroke="#4B5563"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
